import { useCallback, useRef } from 'react';

import { useQuery } from '@tanstack/react-query';
import { pendingAffiliateService } from 'v2/services/affiliate/pendingAffiliate';

export const usePendingAffiliatesSummaryList = () => {
  const forceRef = useRef(false);

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['pendingAffiliatesSummaryList'],
    queryFn: () => {
      const force = forceRef.current;

      if (force) {
        forceRef.current = false;
      }

      return pendingAffiliateService.getPendingAffiliatesSummaryList(force);
    }
  });

  const refetchWithParams = useCallback(
    (force = false) => {
      forceRef.current = force;
      return refetch();
    },
    [refetch]
  );

  return {
    summaryList: data?.data,
    isLoading,
    refetch: refetchWithParams
  };
};
